



































import Vue, { PropOptions } from 'vue'
import { InputEvent, Message } from '@/interfaces'
import IconFlag from '@/components/icons/IconFlag.vue'

export default Vue.extend({
  name: 'MessageTab',
  components: {
    IconFlag,
  },
  data() {
    return {
      value: '',
    }
  },
  props: {
    message: {
      type: Object,
    } as PropOptions<Message>,
    isActive: Boolean,
  },
  methods: {
    handleSelect(event: InputEvent) {
      this.value = event.target.value
    },
  },
})
